import { ComponentProps, ElementType } from 'react';
import styled from 'styled-components';
import BaseTab, { TabProps } from '@mui/material/Tab';
import { fontSize, fontWeight } from '../../style/utils';

type StyledTabProps<C extends ElementType = ElementType> = TabProps & {
  $size?: 'small';
  component?: C;
} & ComponentProps<C>;

const Tab = styled(BaseTab)<StyledTabProps>`
  text-transform: none;
  color: ${({ theme }) => theme.palette.content.primary};
  font-size: ${fontSize('base')};
  font-weight: ${fontWeight('regular')};
  &.MuiTab-root {
    height: ${({ $size }) => ($size === 'small' ? '42px' : undefined)};
  }

  :hover {
    background-color: ${({ theme }) => theme.palette.surface.muted};
  }

  & > svg {
    color: ${({ theme }) => theme.palette.content.secondary};
  }

  &.Mui-selected {
    color: ${({ theme }) => theme.palette.content.translucent.primary};
    font-weight: ${({ theme }) => theme.typography.fontWeightMedium};

    & > svg {
      color: ${({ theme }) => theme.palette.content.translucent.primary};
    }
  }
`;

export default Tab;
